import React from 'react';
import styled from 'styled-components';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';

const AlertText = styled.div`
    font-family: 'AvenirNextWorld Regular';
    font-size: ${(props) => (props.fontSize ? props.fontSize : '13px')};
    letter-spacing: -0.1px;
    color: ${(props) => (props.color ? props.color : '#ED002A')};
    opacity: 1;
    padding: ${(props) => props.padding};
`;

const AlertMsg = ({ message }) => {
    return (
        <>
            <img
                src={AlertCircleOutline}
                height="16px"
                width="16px"
                style={{ margin: '2px 6px 0 0' }}
            />
            <AlertText>{message}</AlertText>
        </>
    );
};

export default AlertMsg;
